/* RESPONSIBLE TEAM: team-email */
import Model, { attr, belongsTo } from '@ember-data/model';
import type Role from '../role';

export type ObjectType = 'sidebar_section';

type PinnedSections = { intercomModuleIdentifier?: string; inboxAppId?: number };
export default class Component extends Model {
  @belongsTo('role', { async: false }) declare role: Role;
  @attr('string') declare componentType: ObjectType;
  @attr() declare configuration: PinnedSections[];
}
